import { Controller } from "@hotwired/stimulus"

// Ignores repeat submits of an exercise launch form, so a double-click on a slow
// redirect to IAGO doesn't record two sessions. Re-armed when the page comes back
// from the back/forward cache.
export default class extends Controller {
  connect() {
    this.rearm = (event) => { if (event.persisted) this.submitted = false }
    window.addEventListener("pageshow", this.rearm)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.rearm)
  }

  submit(event) {
    if (this.submitted) event.preventDefault()
    this.submitted = true
  }
}
